export enum TradingGroupClientTypesEnum {
    All,
    Individual,
    Company
}
